/**
 * @generated SignedSource<<6ed84c2a417cd2fa4c87a71bf5ce1ef2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRow$data = {
  readonly closed: boolean;
  readonly closedIssueCount: number;
  readonly description: string | null | undefined;
  readonly dueOn: string | null | undefined;
  readonly id: string;
  readonly openIssueCount: number;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMetadata">;
  readonly " $fragmentType": "MilestoneRow";
};
export type MilestoneRow$key = {
  readonly " $data"?: MilestoneRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedIssueCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openIssueCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowMetadata"
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "a2addc2bb1aaa14a6a90f585242ad5f9";

export default node;
